import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { BaseTab } from '@/components/ui/Tab/BaseTab';
export const BorderTab = (props) => {
    const { activeValue, children, className, disabled, onChange, paddingClassName = 'py-4 md:py-16', to, value, widthClassName = 'w-[170px]', } = props;
    const classNames = useMemo(() => ({
        button: {
            active: 'text-turquoise-blue-100 border-turquoise-blue-100',
            inactive: 'text-textGray border-gray-300',
            normal: clsx('bg-none border-0 border-b border-b-2 border-solid', 'hover:text-turquoise-blue-100 hover:border-turquoise-blue-100', paddingClassName),
        },
        tab: {
            normal: clsx(widthClassName, className),
        },
    }), [className, paddingClassName, widthClassName]);
    return (_jsx(BaseTab, Object.assign({ activeValue: activeValue, classNames: classNames, disabled: disabled, onChange: onChange, to: to, value: value }, { children: children }), value));
};
